import { useEffect, useMemo } from "react";
import { Modal, Form, Input, Button, Select } from "antd";

const { Option } = Select;

const AddMasterModal = ({
  open,
  onClose,
  onSave,
  title,
  masterType,
  groups = [],
  categories = [],
  defaultGroupId = null,
  defaultCategoryId = null,
}) => {
  const [form] = Form.useForm();
  const isUnit = masterType === "unit";
  const isCategory = masterType === "category";
  const isModel = masterType === "model";

  // Pre-fill the single parent select with whatever was already chosen in the main form
  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        group_id: defaultGroupId || undefined,
        category_id: defaultCategoryId || undefined,
      });
    }
  }, [open, defaultGroupId, defaultCategoryId, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      const nameValue = masterType === "unit" ? values.unit_name : values.name;

      if (!nameValue || !nameValue.trim()) {
        return Modal.warning({ title: "Name cannot be empty" });
      }

      if (masterType === "unit" && (!values.unit_symbol || !values.unit_symbol.trim())) {
        return Modal.warning({ title: "Unit Symbol is required" });
      }

      if (isCategory && !values.group_id) {
        return Modal.warning({ title: "Please select a Group" });
      }

      if (isModel && !values.category_id) {
        return Modal.warning({ title: "Please select a Category" });
      }

      await onSave({
        ...values,
        name: nameValue?.trim(),
        unit_name: values.unit_name?.trim(),
        unit_symbol: values.unit_symbol?.trim(),
      });
      form.resetFields();
    } catch (err) {
      // ✅ AntD validation error — DO NOTHING
    }
  };

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        {/* Category creation → needs only its direct parent: Group */}
        {isCategory && (
          <Form.Item
            name="group_id"
            label="Group"
            rules={[{ required: true, message: "Group is required" }]}
          >
            <Select placeholder="Select group">
              {groups.map((g) => (
                <Option key={g.group_id} value={g.group_id}>
                  {g.group_name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        {/* Sub Category (model) creation → needs only its direct parent: Category */}
        {isModel && (
          <Form.Item
            name="category_id"
            label="Category"
            rules={[{ required: true, message: "Category is required" }]}
          >
            <Select placeholder="Select category">
              {categories.map((c) => (
                <Option key={c.category_id} value={c.category_id}>
                  {c.category_name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        )}

        {/* Unit Name / Generic Name / Category Name / Sub Category Name */}
        <Form.Item
          name={isUnit ? "unit_name" : "name"}
          label={isUnit ? "Unit Name" : "Name"}
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input placeholder={isUnit ? "Enter Unit Name" : "Enter Name"} />
        </Form.Item>

        {/* Unit Symbol – ONLY for Unit */}
        {isUnit && (
          <Form.Item
            name="unit_symbol"
            label="Unit Symbol"
            rules={[{ required: true, message: "Unit Symbol is required" }]}
          >
            <Input placeholder="Eg: Kg, Nos, Ltr" />
          </Form.Item>
        )}

        <Button type="primary" block onClick={handleSubmit}>
          Save
        </Button>
      </Form>
    </Modal>
  );
};

export default AddMasterModal;